'use client'
import { createContext, useCallback, useMemo, useState } from 'react'
import type { FC, ReactNode } from 'react'

export enum MODALS {
  MENU = 'modal_menu',
  BENEFITS = 'modal_benefits',
  VIDEO = 'modal_video',
  POP_UP = 'modal_popup',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface iDefaultModal { isActive: boolean, payload?: any }

// interface iModalAuthPayload {
//   payload: {
//     level: string
//   }
// }

type TypeModalException = object
// type TypeModalException = {
//   [MODALS.AUTH]: iModalAuthPayload
// }

// Utility to merge two Definitions: B object properties shadowing -> A object properties
type $Merge<TA, TB> = Omit<TA, keyof TB> & TB;
// Getting the Base+Extended type of an Modal
type TypeModalById<A extends MODALS> = A extends keyof TypeModalException ? $Merge<iDefaultModal, TypeModalException[A]> : iDefaultModal


type TypeModals = {
  [key in MODALS]?: TypeModalById<key>
}
type TypeModalsState = {
  modals: TypeModals,
  setModal: (modal: { [key: string]: iDefaultModal } | ((prev: TypeModals) => TypeModals)) => void,
  someModalIsActive: boolean
}

const initialModalsState: TypeModalsState = {
  modals: {},
  setModal: () => {},
  someModalIsActive: false
  //someModalIsActive: boolean at least one modal is Active ?
}

interface iModalsProviderProps {
  children: ReactNode
}

export const ModalsContext = createContext<TypeModalsState | null>(initialModalsState)

const getInitialModals = () => {
	return Object.values(MODALS).reduce((acc, modal) => {
		acc[modal] = { isActive: false }
		return acc
	}, {} as TypeModals)
}

export const ModalsProvider: FC<iModalsProviderProps> = ({ children }) => {
  const [modals, setModals] = useState<TypeModals>(getInitialModals())
  const [someModalIsActive, setSomeModalIsActive] = useState(false)

  const setModal = useCallback((modal: { [key: string]: iDefaultModal } | ((prev: TypeModals) => TypeModals)) => {
    setModals(prevModals => {
      const nextModals = typeof modal === 'function' ? modal(prevModals) : { ...prevModals, ...modal }
      const someActive = Object.values(nextModals).some(m => m?.isActive)
      setSomeModalIsActive(someActive)
      return nextModals
    })
  }, [])

  const contextValue = useMemo(() => ({ modals, setModal, someModalIsActive }), [modals, setModal, someModalIsActive])

  return (<ModalsContext.Provider value={contextValue}>
    {children}
  </ModalsContext.Provider>)
}
